import React from "react";

import { useSelector } from "react-redux";
import {
  Grid,
  IconButton,
  Pagination,
  PaginationItem,
  Skeleton
} from "@mui/material";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

import useStyle from "./Suppot.style";

const SubjectSupport = ({
  handleTicket,
  handlePageChange,
  selectedTicketId,
  totalPages,
  currentPage,
  setCurrentPage
}) => {
  const { subjectlist, subjectloading } = useSelector(
    (state) => state.supportmodal
  );

  const classes = useStyle();

  const paginationHandler = (event, page) => {
    setCurrentPage(page);
  };

  return (
    <>
      {subjectloading ? (
        <Grid className={classes.subjectLoader}>
          <Skeleton
            variant="rectangular"
            className={classes.circularprogress}
          />
        </Grid>
      ) : (
        <>
          <div className={classes.pagination}>
            {subjectlist?.rows?.map(
              (row) =>
                row?.ticket?.trim()?.length > 0 && (
                  <div
                    className={`${classes.subjectlist} ${
                      row?.id === selectedTicketId
                        ? classes.selectedSubject
                        : ""
                    }`}
                    key={row.id}
                    onClick={() => handleTicket(row.id)}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        handleTicket(row?.id);
                      }
                    }}
                    role="button"
                    tabIndex={0}
                  >
                    <span>{row?.ticket}</span>
                  </div>
                )
            )}
          </div>

          {totalPages > 1 && (
            // <div className={classes.paginationWrap}>
            //   <Button
            //     disabled={currentPage === 1}
            //     className={classes.paginationBtn}
            //     onClick={() => handlePageChange("previous")}
            //   >
            //     &lt;
            //   </Button>
            //   {Array.from({ length: totalPages }, (_, index) => (
            //     <Button
            //       key={index}
            //       disabled={currentPage === index + 1}
            //       style={{
            //         color: "white",
            //         marginRight: "2px",
            //         borderRadius: "100%",
            //         minWidth: "18px",
            //         fontSize: "12px",
            //         height: "18px",
            //         padding: "0",
            //         cursor: "pointer",
            //         backgroundColor:
            //           currentPage === index + 1 ? "#4c0f77" : "transparent"
            //       }}
            //       onClick={() => setCurrentPage(index + 1)}
            //     >
            //       {index + 1}
            //     </Button>
            //   ))}
            //   <Button
            //     disabled={currentPage === totalPages}
            //     className={classes.paginationBtnNextPrev}
            //     onClick={() => handlePageChange("next")}
            //   >
            //     &gt;
            //   </Button>
            // </div>
            <Grid className={`${classes.supportPaginationWrap}`}>
              <Pagination
                page={currentPage}
                count={totalPages}
                size="small"
                onChange={paginationHandler}
                renderItem={(item) => {
                  if (
                    (item.type === "page" && !item?.selected) ||
                    item.type === "end-ellipsis" ||
                    item.type === "start-ellipsis"
                  ) {
                    return null;
                  }
                  return (
                    <PaginationItem
                      components={{
                        next: () => (
                          <IconButton
                            disableRipple
                            className={classes.paginationIconWrap}
                          >
                            <ArrowRightIcon />
                          </IconButton>
                        ),
                        previous: () => (
                          <IconButton
                            disableRipple
                            className={classes.paginationIconWrap}
                          >
                            <ArrowLeftIcon />
                          </IconButton>
                        )
                      }}
                      {...item}
                    />
                  );
                }}
              />
            </Grid>
          )}
        </>
      )}
    </>
  );
};

export default SubjectSupport;
